module.exports = __webpack_public_path__ + "static/media/BankTxnFileTemplate.16da5f97.xlsx";